import { IconButton, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { chartPalette, ramps } from "../../../common/theme/brandTokens";

const dragColor = chartPalette[3];

export const FileUploaded = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 8,
  maxWidth: "200px",
  color: dragColor,
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  flex: 1,
  padding: 0,
  backgroundColor: "transparent",
  "& .MuiInputBase-root": {
    maxHeight: 200,
    overflowY: "auto",
    alignItems: "stretch",
    boxSizing: "border-box",
  },
  "& .MuiInputBase-inputMultiline": {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    boxSizing: "border-box",
  },
}));


export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "transparent",
  },
}));

export const FunctionalityWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  width: "auto",
  height: "auto",
  justifyContent: "center",
  alignItems: "center",
  paddingRight: theme.spacing(1),
}));

export const MetaFunctionalityWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: `0px ${theme.spacing(2)}`,
  fontSize: "20px",
  gap: 10,
}));

export const DropBox = styled("div")(({ theme }) => ({
  gap: 5,
  display: "flex",
  width: "100%",
  height: "100%",
  alignItems: "center",
  justifyContent: "center",
  color: dragColor,
}));


export const ChatInputBox = styled("div")(
  ({ theme }) => ({
    borderRadius: "10px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    maxWidth: "1200px",
    minHeight: "56px",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.mode === "dark" ? ramps.neutral[800] : ramps.neutral[100],
    outline: "none",
  }),
);
